import { ICON } from "../../../components/Icon/data"
import { FORMAT_TYPE } from "../../../data/variables"
import i18n from "../../../i18n"

type CardMap = {
  [key: string]: {
    icon: string
    text: string
    unit?: string
    path?: string
    format?: string
    showArrow?: boolean
  }
}

export enum CARD_KEYS {
  MAX_SPEED_LIMIT = 'max_speed_over_limit',
  AVG_SPEED_LIMIT = 'avg_max_speed_over_limit',
  SPEED_VIOLATIONS = 'speed_violations',
  ACTIVE_VEHICLES = 'active',
  HOURS_IDLE = 'idle',
  DISTANCE_DRIVEN = 'distance',
  AVG_MAX_SPEED = 'avg_max_speed',
  HOURS_STOP = 'stop_duration',
  MAX_SPEED = 'max_speed',
  FLEET_DRIVING_QUALITY = 'avg_speeding_grade',
  DUE_FOR_MAINTENANCE = 'maintenance',
  CO2_EMISSIONS = 'emissions'
}

export const CARD_MAP: CardMap = {
  [CARD_KEYS.MAX_SPEED_LIMIT]: {
    icon: ICON.ROUND_METER,
    text: i18n.t('max speed over limit'),
    unit: i18n.t('km/h'),
    format: FORMAT_TYPE.NUMBER,
    showArrow: false,
  },
  [CARD_KEYS.AVG_SPEED_LIMIT]: {
    icon: ICON.ROUND_METER,
    text: i18n.t('average max speed over limit'),
    unit: i18n.t('km/h'),
    format: FORMAT_TYPE.NUMBER,
    showArrow: false,
  },
  [CARD_KEYS.SPEED_VIOLATIONS]: {
    icon: ICON.ROUND_METER,
    text: i18n.t('speed violations'),
    format: FORMAT_TYPE.NUMBER,
    showArrow: true,
  },
  [CARD_KEYS.ACTIVE_VEHICLES]: {
    icon: ICON.TRAFFIC_EVENT,
    text: i18n.t('active vehicles'),
    format: FORMAT_TYPE.NUMBER,
    showArrow: true,
    path: 'avg_active_mobiles_per_day'
  },
  [CARD_KEYS.HOURS_IDLE]: {
    icon: ICON.PAUSE,
    text: i18n.t('hours idle'),
    format: FORMAT_TYPE.DURATION,
    showArrow: true,
    path: 'idle_seconds'
  },
  [CARD_KEYS.DISTANCE_DRIVEN]: {
    icon: ICON.ROAD,
    text: i18n.t('distance driven'),
    unit: 'km',
    format: FORMAT_TYPE.NUMBER,
    showArrow: true,
    path: 'distance_total_km'
  },
  [CARD_KEYS.AVG_MAX_SPEED]: {
    icon: ICON.ROUND_METER,
    text: i18n.t('average max speed'),
    unit: i18n.t('km/h'),
    format: FORMAT_TYPE.NUMBER,
    showArrow: false,
  },
  [CARD_KEYS.HOURS_STOP]: {
    icon: ICON.PAUSE,
    text: i18n.t('hours stop'),
    format: FORMAT_TYPE.DURATION,
    showArrow: true,
    path: 'stop_duration_sec'
  },
  [CARD_KEYS.MAX_SPEED]: {
    icon: ICON.ROUND_METER,
    text: i18n.t('max speed'),
    unit: i18n.t('km/h'),
    format: FORMAT_TYPE.ONE_DECIMAL,
    showArrow: false,
  },
  [CARD_KEYS.FLEET_DRIVING_QUALITY]: {
    icon: ICON.CARS,
    text: i18n.t('Fleet driving quality'),
    format: FORMAT_TYPE.LETTER_GRADE,
    showArrow: true,
  },
  [CARD_KEYS.DUE_FOR_MAINTENANCE]: {
    icon: ICON.TOOL_KIT,
    text: i18n.t('Vehicles due for maintenance'),
    showArrow: false,
    path: 'total_vehicles_due_for_maintenance'
  },
  [CARD_KEYS.CO2_EMISSIONS]: {
    icon: ICON.CO2,
    text: i18n.t('CO2 emissions'),
    unit: 'kg',
    format: FORMAT_TYPE.NUMBER,
    showArrow: true,
    path: 'emissions_total_kg'
  }
}